'use client';

import dynamic from 'next/dynamic';

// pdf.js touches `window`/`document`; keep it out of the server bundle and
// out of the initial client chunk (it is ~1.5 MB and only needed on demand).
export const LazyPdfFirstPage = dynamic(
  () => import('./PdfDocument').then(module => module.PdfFirstPage),
  { ssr: false, loading: () => null }
);

export const LazyPdfPages = dynamic(
  () => import('./PdfDocument').then(module => module.PdfPages),
  { ssr: false }
);
